// @flow
import React, { Component, type ComponentType } from "react";
import RandomColor from "random-material-color";
import Spinner from "@atlaskit/spinner";
import Button from "@material-ui/core/Button";
import FeedbackIcon from "@material-ui/icons/Feedback";
import scrollTo from "scroll-to";

import { pageview } from "../utils/events";
import { getOriginalFromId } from "../utils/image";
import { locationImageUrl } from "../utils/map";
import { isCD } from "../rest/utils/envDetection";

import {
    Blog,
    Content,
    TitleImage,
    TitleMap,
    Title,
    Summary,
    Description,
    Links,
    NoBlogs,
    Feedback,
    PageLink
} from "./styled";
import { Centered } from "../utils/styled";

export const HOME = "home";
const JOURNALS = "journals";
const MESSAGES = "messages";
const MAP = "MAP";
const PHOTOS = "photos";

type Props = {|
    onShowFeedback: Function,
    NoUserView: ComponentType<any>,
    PasswordView: ComponentType<any>,
    BlogCardListView: ComponentType<any>,
    JournalsPageView: ComponentType<any>,
    MessagesPageView: ComponentType<any>,
    PhotosPageView: ComponentType<any>,
    UpdatePanel: ComponentType<any>,
    Map: ComponentType<any>,
    userInfo: ComponentType<any>,
    blogs: ComponentType<any>
|};

type State = {
    isLoading: boolean,
    page: String
};

class HomePageView extends Component<Props, State> {
    // We set the loading state at the beginning after which the state can only be set to
    // loaded through the spinner. This allows us to have a 'completed' animated for the spinner.
    constructor(props) {
        super(props);
        const { userInfo } = props;
        this.state = {
            isLoading: userInfo === null,
            page: null
        };
    }

    nav(page) {
        this.setState({ page });

        pageview(page);

        scrollTo(0, 350, {
            ease: "out-circ",
            duration: 500
        });
    }

    render() {
        const {
            NoUserView,
            BlogCardListView,
            PasswordView,
            userInfo,
            blogs,
            JournalsPageView,
            MessagesPageView,
            PhotosPageView,
            UpdatePanel,
            Map,
            onShowFeedback
        } = this.props;
        const { page, isLoading } = this.state;

        if (isLoading) {
            return (
                <Centered>
                    <Spinner
                        size="medium"
                        isCompleting={this.props.userInfo != null}
                        onComplete={() => this.setState({ isLoading: false })}
                    />
                </Centered>
            );
        }

        if (userInfo.length === 0) {
            return (
                <div>
                    <NoUserView />
                </div>
            );
        }

        const user = userInfo[0];

        const headerStyle =
            user.hpImage && user.hpImage !== null
                ? {
                      backgroundImage: `url(${getOriginalFromId(user, user.hpImage)})`
                  }
                : {
                      backgroundColor: RandomColor.getColor({
                          shades: ["200", "300"],
                          text: user.title
                      })
                  };

        const mapImageUrl = isCD
            ? `url(./DCIM/100JEALO/location.png)`
            : `url(${locationImageUrl(user)})`;

        return (
            <div>
                <TitleImage style={headerStyle} />

                {user.location !== null && (
                    <div style={{ position: "absolute", left: "50%" }}>
                        <TitleMap
                            alt={`${user.location.name}, ${user.location.country}`}
                            title={`${user.location.name}, ${user.location.country}`}
                            style={{
                                backgroundImage: mapImageUrl
                            }}
                            onClick={() => this.nav(MAP)}
                        />
                    </div>
                )}

                {isCD || user.blogPassword === "ok" ? (
                    <div>
                        <Summary>
                            <Title>{user.title}</Title>

                            <Description>{user.description}</Description>
                            {blogs !== null &&
                                blogs.length === 0 && (
                                    <NoBlogs key="blogs-spinner">
                                        There are no blogs written yet.
                                    </NoBlogs>
                                )}
                            {blogs !== null &&
                                blogs.length > 0 && (
                                    <div>
                                        <Links>
                                            <PageLink
                                                style={{
                                                    textDecoration: page === HOME ? "underline" : ""
                                                }}
                                                onClick={() => this.nav(HOME)}
                                            >
                                                Home
                                            </PageLink>
                                            &nbsp;&nbsp;
                                            <PageLink
                                                style={{
                                                    textDecoration:
                                                        page === PHOTOS ? "underline" : ""
                                                }}
                                                onClick={() => this.nav(PHOTOS)}
                                            >
                                                Photos
                                            </PageLink>
                                            &nbsp;&nbsp;
                                            <PageLink
                                                style={{
                                                    textDecoration:
                                                        page === MESSAGES ? "underline" : ""
                                                }}
                                                onClick={() => this.nav(MESSAGES)}
                                            >
                                                Messages
                                            </PageLink>
                                            &nbsp;&nbsp;
                                            {1 === 0 && <a href="#map">Map</a>}
                                            <PageLink
                                                style={{
                                                    textDecoration:
                                                        page === JOURNALS ? "underline" : ""
                                                }}
                                                onClick={() => this.nav(JOURNALS)}
                                            >
                                                Archive
                                            </PageLink>
                                        </Links>
                                    </div>
                                )}
                        </Summary>
                        <Content>
                            <Blog>
                                <UpdatePanel />
                            </Blog>
                            {(page === null || page === HOME) && (
                                <Blog id="top-blog">
                                    <BlogCardListView />
                                </Blog>
                            )}

                            {page === MESSAGES && (
                                <Blog id="top-blog">
                                    <MessagesPageView />
                                </Blog>
                            )}

                            {page === PHOTOS && (
                                <Blog id="top-blog">
                                    <PhotosPageView />
                                </Blog>
                            )}

                            {page === JOURNALS && (
                                <Blog id="top-blog">
                                    <JournalsPageView />
                                </Blog>
                            )}

                            {page === MAP && <Map />}
                        </Content>
                    </div>
                ) : (
                    <Summary>
                        <Title>{user.title}</Title>
                        <PasswordView />
                    </Summary>
                )}

                <Feedback>
                    <Button
                        onClick={onShowFeedback}
                        variant="fab"
                        color="primary"
                        style={{
                            position: "absolute",
                            right: 20,
                            bottom: 20
                        }}
                        aria-label="Add"
                    >
                        <FeedbackIcon />
                    </Button>
                </Feedback>
            </div>
        );
    }
}

export default HomePageView;



// WEBPACK FOOTER //
// ./src/home-page-view/view.js